import { css, StyleSheet } from "aphrodite";
import { useEffect } from "react";
import { useState } from "react";
import dayjs from "dayjs";

import AchievementBadge from "../Prime/AchievementBadge";

import { capitalize } from "../../../../utils/TextProcessing";

const Achievements = ({
  agent,
  city,
  state,
  badgeStyles,
  iconStyles,
  className,
}) => {
  let agentAchievements = agent.achievements;
  agentAchievements = agentAchievements.map((achievement) => {
    if (achievement.toLowerCase().includes("[city]")) {
      return achievement.replace(/\[city\]/gi, city);
    } else if (achievement.toLowerCase().includes("[state]")) {
      return achievement.replace(/\[state\]/gi, state);
    }
    return achievement;
  });

  const [achievements, setAchievements] = useState(agentAchievements);

  useEffect(() => {
    let agentAchievements = agent.achievements;
    agentAchievements = agentAchievements.map((achievement) => {
      if (achievement.toLowerCase().includes("[city]")) {
        return achievement.replace(/\[city\]/gi, city);
      } else if (achievement.toLowerCase().includes("[state]")) {
        return achievement.replace(/\[state\]/gi, state);
      }
      return achievement;
    });
    setAchievements(agentAchievements);
  }, [agent.achievements]);

  const renderAchievements = () => {
    return achievements.map((achievement, index) => {
      return (
        <AchievementBadge
          achievement={`${capitalize(achievement)} ${dayjs()
            .subtract(1, "year")
            .year()}`}
          index={index}
          badgeStyles={[styles.achievement, badgeStyles]}
          iconStyles={[iconStyles]}
          key={index}
        />
      );
    });
  };
  return (
    <div className={css(styles.acheivementsContainer, className)}>
      {renderAchievements()}
    </div>
  );
};

const styles = StyleSheet.create({
  acheivementsContainer: {
    display: "flex",
    gap: 10,
    alignItems: "center",
    flexWrap: "wrap",
  },
  achievement: {},
});
export default Achievements;
